/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const sendBundlePdfReport = `mutation SendBundlePdfReport($input: BundleReportInput!) {
    sendBundlePdfReport(input: $input)
  }
  `;
